import * as Configuration from '../../app.constants.js';

export class UserOptinImportService {
  constructor(AsyncRequestFactory, $filter, DropdownItemsFactory, UserFactory) {
    this.$filter = $filter;
    this.AsyncRequestFactory = AsyncRequestFactory;
    this.DropdownItemsFactory = DropdownItemsFactory;
    this.UserFactory = UserFactory;
  }

  importOptin(companyId, siteId, optinId, data) {
    return this.AsyncRequestFactory.post(companyId, `${Configuration.constants.baseUrl}api/1.0/companies/${companyId}/sites/${siteId}/optins/${optinId}/user-optin-import`, data);
  }

  static UserOptinImportFactory(AsyncRequestFactory, $filter, DropdownItemsFactory, UserFactory) {
    return new UserOptinImportService(AsyncRequestFactory, $filter, DropdownItemsFactory, UserFactory);
  }
}

UserOptinImportService.UserOptinImportFactory.$inject = ['AsyncRequestFactory', '$filter', 'DropdownItemsFactory', 'UserFactory'];
